import { Component, Inject, Input, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CorretorService } from '../../services/corretor.service';
import { NavigationEnd, Router } from '@angular/router';
import { CorretorResposneDto } from '../../dto/corretor-response.dto';

@Component({
   selector: 'app-corretor-bio',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './corretor-bio.component.html',
   styleUrls: ['./corretor-bio.component.scss']
})
export class CorretorBioComponent {
   @Input() codigo: number;

   bioExpandida: boolean = false;

   corretor?: CorretorResposneDto;

   constructor(
      private corretorService: CorretorService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private router: Router
   ) {}

   ngOnChanges(changes: SimpleChanges) {
      if (changes['codigo'] && this.codigo) {
         this.buscarCorretor();
      }
   }

   async ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  window.scrollTo(0, 0);
               });
            }
         });
      }
   }

   async buscarCorretor() {
      this.corretor = await this.corretorService.getCorretorByCodigo(this.codigo).catch((e) => {
         this.router.navigate(['/']);
         return undefined;
      });

   }

   mobile: boolean = false;
   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }

     // 🔹 Formata o telefone para o padrão internacional do WhatsApp
  getFormattedPhone(): string {
    const digits = this.corretor.telefone.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (digits.length === 11) {
      return `55${digits}`; // Adiciona código do Brasil (55)
    }
    return digits; // Caso já esteja correto
  }

  // 🔹 Abre o WhatsApp com o número formatado
  openWhatsApp(): void {
    const phone = this.getFormattedPhone();
    const message = encodeURIComponent("Olá! Gostaria de mais informações.");
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }

  // 🔹 Abre o e-mail com o destinatário preenchido
  openEmail(): void {
    const subject = encodeURIComponent("Informações sobre o imóvel");
    const body = encodeURIComponent("Olá, gostaria de mais detalhes sobre o imóvel...");
    const mailtoUrl = `mailto:${this.corretor.email}?subject=${subject}&body=${body}`;
    window.open(mailtoUrl, '_blank');
  }

}
